import { __decorate } from "tslib";
import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
let BreadCrumbsStore = class BreadCrumbsStore extends VuexModule {
    flowKey = 'base';
    flowName = '';
    localStorageKey = 1;
    flows = {
        'base': [
            'BREADCRUMBS.APPOINTMENTS.TYPES',
            'BREADCRUMBS.ORGANISATION',
            'BREADCRUMBS.ADVISORS',
            'BREADCRUMBS.RECAP',
        ],
        'partners': [
            'BREADCRUMBS.APPOINTMENTS.TYPES',
            'BREADCRUMBS.BUSINESS.PARTNER.TITLE',
            'BREADCRUMBS.TECH',
            'BREADCRUMBS.RECAP',
        ],
        'hubs': [
            'BREADCRUMBS.APPOINTMENTS.TYPES',
            'BREADCRUMBS.HUBS',
            'BREADCRUMBS.ADVISORS',
            'BREADCRUMBS.RECAP',
        ],
        'branches': [
            'BREADCRUMBS.APPOINTMENTS.TYPES',
            'BREADCRUMBS.BRANCHES',
            'BREADCRUMBS.ADVISORS',
            'BREADCRUMBS.RECAP',
        ],
        'hubs-and-branches': [
            'BREADCRUMBS.APPOINTMENTS.TYPES',
            'BREADCRUMBS.HUBS.BRANCHES',
            'BREADCRUMBS.ADVISORS',
            'BREADCRUMBS.RECAP',
        ],
        'appointment-matmut': [
            `BREADCRUMBS.CUSTOM.DETAILS`,
            'LABEL.APPOINTMENT.TYPE',
            'BREADCRUMBS.LOCATION',
            'BREADCRUMBS.ADDRESS',
            'BREADCRUMBS.RECAP',
        ],
    };
    setFlowKey(key) {
        window.localStorage.setItem('SASS_FLOW_KEY', key);
        this.flowKey = key;
        this.localStorageKey += 1;
    }
    setFlowName(key) {
        window.localStorage.setItem('SASS_FLOW_NAME', key);
        this.flowName = key;
    }
    clearFlowKey() {
        window.localStorage.removeItem('SASS_FLOW_KEY');
        this.flowKey = 'base';
        this.localStorageKey += 1;
    }
    get currentFlow() {
        return this.flows[this.currentFlowKey];
    }
    get currentFlowKey() {
        if (this.localStorageKey && window.localStorage.getItem('SASS_FLOW_KEY')) {
            return window.localStorage.getItem('SASS_FLOW_KEY');
        }
        return this.flowKey;
    }
};
__decorate([
    Mutation
], BreadCrumbsStore.prototype, "setFlowKey", null);
__decorate([
    Mutation
], BreadCrumbsStore.prototype, "setFlowName", null);
__decorate([
    Mutation
], BreadCrumbsStore.prototype, "clearFlowKey", null);
BreadCrumbsStore = __decorate([
    Module({
        namespaced: true,
    })
], BreadCrumbsStore);
export default BreadCrumbsStore;
